import { SortOrder } from "@/generated/graphql";
import { ITEM_LIMIT } from "@/lib/constants/shared";

export interface ProjectsByParentOptions {
  parentId: string | null;
  searchText?: string | null | undefined;
  sortBy?: SortOrder | undefined;
  isTrash?: boolean | undefined;
  skip?: boolean | undefined;
  limit?: number | undefined;
}

export const getProjectsByParentIdVars = ({
  parentId,
  searchText,
  sortBy = SortOrder.Recent,
  isTrash = false,
  limit,
}: ProjectsByParentOptions) => {
  return {
    parentId,
    limit: limit ?? (isTrash ? 100 : ITEM_LIMIT.generalItemLimit),
    offset: 0,
    searchText: searchText || null,
    sortBy,
    isTrash,
  };
};
